// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/202606290109/js/" + chunkId + "." + {"44":"943ad21e","225":"ad3afd1a","481":"73876148","486":"4471f956","770":"6c7f2a94"}[chunkId] + ".0.7451612384180486.chunk.js";
};